import React from 'react';

export default function Accounts(props) {
  return <div className="Login">Accounts</div>;
}
